import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useIntl } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';
import { string } from 'prop-types';
import classNames from 'classnames';

import { parse } from '../../util/urlHelpers';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { Button, FieldTextInput, Form, IconSearch } from '..';

import css from './SearchBar.module.css';

const SearchBar = props => {
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const intl = useIntl();

  const {
    onSubmit,
    className = null,
    buttonClassName = null,
    iconClassName = null,
    inputClassName = null,
    buttonContent = null,
  } = props;

  const currentSearchParams = useMemo(() => parse(location.search), [location?.search]);

  const defaultOnSubmit = useCallback(
    values => {
      const { search } = values;

      const redirectTo = createResourceLocatorString(
        'SearchPage',
        routeConfiguration,
        {},
        { ...currentSearchParams, page: 1, search }
      );
      history.replace(redirectTo);
    },
    [history, currentSearchParams]
  );

  return (
    <FinalForm
      initialValues={{
        search: currentSearchParams?.search ?? '',
      }}
      onSubmit={onSubmit || defaultOnSubmit}
      render={fieldRenderProps => {
        const { handleSubmit, formId } = fieldRenderProps;

        return (
          <Form className={classNames(css.root, className)} onSubmit={handleSubmit}>
            <FieldTextInput
              id={formId ? `${formId}.search` : 'search'}
              name="search"
              className={classNames(css.input, inputClassName)}
              placeholder={intl.formatMessage({
                id: 'ManageListingsPage.searchPlaceholder',
              })}
            />
            <Button className={classNames(css.button, buttonClassName)}>
              <IconSearch className={classNames(css.icon, iconClassName)} />
              {buttonContent}
            </Button>
          </Form>
        );
      }}
    />
  );
};

SearchBar.propTypes = {
  className: string,
  inputClassName: string,
  buttonClassName: string,
  iconClassName: string,
};

export default SearchBar;
